
import React, { useEffect, useState, useCallback } from 'react';
import SwitchComponent from 'src/components/shared/Form/Switch';
import InputSelect from 'src/components/shared/Form/Select';
import theme from 'src/config/theme';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { getClinicRequest } from 'src/modules/app/store/appActions';
import storage from 'src/utils/storageUtils';
import { AddContainer, Component4, Texts, Component6 } from './Style';

const FutureOption = ({ innerRef, data, setDoctorProfileData }) => {
    const dispatch = useDispatch();
    const [clinics, setClinics] = useState([]);
    const fetchClinics = useCallback(() => {
        const token = storage.get('TOKEN');
        const fetchData = async () => {
            const response = await new Promise((resolve, reject) =>
                dispatch(getClinicRequest(token, resolve, reject))
            );
            if (response) {
                setClinics(response.data);
                console.log("all clinics inside options", response.data)
            }
        };
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        fetchClinics();
    }, [fetchClinics]);



    const Status = [
        { label: 'Vacation', value: 'Vacation' },
        { label: 'Active', value: 'Active' },
        { label: 'Disable', value: 'Disable' }
    ];



    const initialValues = {
        currentStatus: data?.currentStatus || '',
        interestInOutsourcingMarketing: data?.interestInOutsourcingMarketing || false,
        interestInOutsourcingSupport: data?.interestInOutsourcingSupport || false,
        interestInOutsourcingSocialMedia: data?.interestInOutsourcingSocialMedia || false,
        interestInCollaborationWithPharmacies: data?.interestInCollaborationWithPharmacies || false,
        interestInCollaborationWithLaboratories: data?.interestInCollaborationWithLaboratories || false,
        interestInCollaborationWithSuppliers: data?.interestInCollaborationWithSuppliers || false,
        interestInAnalyticsReports: data?.interestInAnalyticsReports || false,
        associatedClinics: Array.isArray(data?.associatedClinics)
            ? data.associatedClinics
            : []
    }
    const handleSubmit = (values) => {
        setDoctorProfileData(prev => ({
            ...prev,
            futureOptions: values
        }));
    }
    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                innerRef={innerRef}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                    <Form>
                        <AddContainer>
                            <Component4>
                                <Texts>Current Status</Texts>
                                <InputSelect
                                    name="currentStatus"
                                    showNone={false}
                                    options={Status}
                                    variant="outlined"
                                    placeholder="Select"
                                    value={values.currentStatus}
                                    onChange={(value) => setFieldValue('currentStatus', value)}
                                    sx={{
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            borderRadius: '12px',
                                        },
                                    }}
                                />

                            </Component4>

                            <Component6>
                                <Texts>Interest In Out Sourcing Marketing</Texts>
                                <SwitchComponent
                                    name="interestInOutsourcingMarketing"
                                    checked={values.interestInOutsourcingMarketing}
                                    onChange={() => setFieldValue('interestInOutsourcingMarketing', !values.interestInOutsourcingMarketing)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}

                                />
                            </Component6>
                            <Component6>
                                <Texts>Interest InOut Sourcing Support</Texts>
                                <SwitchComponent
                                    name="interestInOutsourcingSupport"
                                    checked={values.interestInOutsourcingSupport}
                                    onChange={() => setFieldValue('interestInOutsourcingSupport', !values.interestInOutsourcingSupport)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Interest In Out Sourcing SocialMedia</Texts>
                                <SwitchComponent
                                    name="interestInOutsourcingSocialMedia"
                                    checked={values.interestInOutsourcingSocialMedia}
                                    onChange={() => setFieldValue('interestInOutsourcingSocialMedia', !values.interestInOutsourcingSocialMedia)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Interest In Collaboration With Pharmacies</Texts>
                                <SwitchComponent
                                    name="interestInCollaborationWithPharmacies"
                                    checked={values.interestInCollaborationWithPharmacies}
                                    onChange={() => setFieldValue('interestInCollaborationWithPharmacies', !values.interestInCollaborationWithPharmacies)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Interest In Collaboration With Laboratories</Texts>
                                <SwitchComponent
                                    name="interestInCollaborationWithLaboratories"
                                    checked={values.interestInCollaborationWithLaboratories}
                                    onChange={() => setFieldValue('interestInCollaborationWithLaboratories', !values.interestInCollaborationWithLaboratories)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Interest In Collaboration With Suppliers</Texts>
                                <SwitchComponent
                                    name="interestInCollaborationWithSuppliers"
                                    checked={values.interestInCollaborationWithSuppliers}
                                    onChange={() => setFieldValue('interestInCollaborationWithSuppliers', !values.interestInCollaborationWithSuppliers)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Interest In Analytics Reports</Texts>
                                <SwitchComponent
                                    name="interestInAnalyticsReports"
                                    checked={values.interestInAnalyticsReports}
                                    onChange={() => setFieldValue('interestInAnalyticsReports', !values.interestInAnalyticsReports)}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component4>
                                <Texts>Associated Clinics</Texts>
                                <InputSelect
                                    name="associatedClinics"
                                    showNone={false}
                                    options={clinics.map(clinic => ({
                                        label: clinic.clinicName,
                                        value: clinic.id,
                                    }))}
                                    variant="outlined"
                                    multiple={true}
                                    placeholder="Select"
                                    value={values.associatedClinics.map(c => c.clinicId || c)}
                                    onChange={(value) => {

                                        const selected = clinics
                                            .filter(clinic => value.includes(clinic.id))
                                            .map(clinic => ({
                                                clinicId: clinic.id,
                                                clinicName: clinic.clinicName,
                                            }));
                                        setFieldValue('associatedClinics', selected);
                                    }}
                                    sx={{
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            borderRadius: '12px',
                                        },
                                    }}
                                />

                            </Component4>

                        </AddContainer>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default FutureOption

